import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/AuthService/auth.service';
import { map, take } from 'rxjs/operators';
import { SessionStorageService } from './storage/session-storage.service';
import { StorageKey } from './storage/storage-model';
const { AUTH_TOKEN } = StorageKey;

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
constructor(private authService: AuthService, private router: Router, private storageService: SessionStorageService) {}
canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
  return this.authService.isLoggedIn.pipe(
    take(1),
    map((isLoggedIn: boolean) => {
      if (this.storageService.read(AUTH_TOKEN) != null) {
      isLoggedIn = true;
      }
      if (!isLoggedIn) {
        this.router.navigate(['/login']);
        return false;
      }
      return true;
    })
  );
}
}
